import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';  // <-- تأكد أن الاستيراد بهذا الشكل

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('لم يتم العثور على عنصر الجذر');
}

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);